import { RootState, useAppSelector } from "../store";
import { ROLE, isInvoiceFeatureEnabled } from "./utils";
import { getActiveRole, getDecryptedUserData } from "./bycrypt";
import { RoleTypesEnum } from "../Admin/Pages/RolesAndPermissions/rolesAndPermissionsTypes";

export const allPermissions = [
  {
    display_name: "Dashboard",
    name: "dashboard",
    options: [
      { label: "View", value: "read", viewType: "checkbox" },
      { label: "Add", value: "add", viewType: "checkbox" },
      { label: "Edit", value: "edit", viewType: "checkbox" },
      { label: "Delete", value: "delete", viewType: "checkbox" },
    ],
  },
  {
    display_name: "Projects",
    name: "projects",
    options: [
      { label: "View", value: "read", viewType: "checkbox" },
      { label: "Add", value: "add", viewType: "checkbox" },
      { label: "Edit", value: "edit", viewType: "checkbox" },
      { label: "Delete", value: "delete", viewType: "checkbox" },
    ],
  },
  {
    display_name: "Design Requests",
    name: "quote_requests",
    options: [
      { label: "View", value: "read", viewType: "checkbox" },
      { label: "Add", value: "add", viewType: "checkbox" },
      { label: "Edit", value: "edit", viewType: "checkbox" },
      { label: "Delete", value: "delete", viewType: "checkbox" },
    ],
  },
  {
    display_name: "Estimates",
    name: "estimate",
    options: [
      { label: "View", value: "read", viewType: "checkbox" },
      { label: "Add", value: "add", viewType: "checkbox" },
      { label: "Edit", value: "edit", viewType: "checkbox" },
      { label: "Delete", value: "delete", viewType: "checkbox" },
    ],
  },
  {
    display_name: "Quotations",
    name: "quotations",
    options: [
      { label: "View", value: "read", viewType: "checkbox" },
      { label: "Add", value: "add", viewType: "checkbox" },
      { label: "Edit", value: "edit", viewType: "checkbox" },
      { label: "Delete", value: "delete", viewType: "checkbox" },
      // Future Options:
      {
        label: "For All Users",
        value: "access_of_all_user",
        viewType: "switch",
      },
      // { label: "Convert to Order", value: "convert_to_order", viewType: "checkbox" },
    ],
  },
  {
    display_name: "Orders",
    name: "orders",
    options: [
      { label: "View", value: "read", viewType: "checkbox" },
      { label: "Add", value: "add", viewType: "checkbox" },
      { label: "Edit", value: "edit", viewType: "checkbox" },
      { label: "Delete", value: "delete", viewType: "checkbox" },
      // Future Options:
      // { label: "Change Status", value: "change_status", viewType: "switch" },
      // { label: "Approve", value: "approve", viewType: "switch" },
    ],
  },
  ...(isInvoiceFeatureEnabled ? [{
    display_name: "Invoice",
    name: "invoice",
    options: [
      { label: "View", value: "read", viewType: "checkbox" },
      { label: "Add", value: "add", viewType: "checkbox" },
      { label: "Edit", value: "edit", viewType: "checkbox" },
      { label: "Delete", value: "delete", viewType: "checkbox" },
    ],
  }] : []),
  // {
  //   display_name: "Jobs",
  //   name: "jobs",
  //   options: [
  //     { label: "View", value: "read", viewType: "checkbox" },
  //     { label: "Add", value: "add", viewType: "checkbox" },
  //     { label: "Edit", value: "edit", viewType: "checkbox" },
  //     { label: "Delete", value: "delete", viewType: "checkbox" },
  //     // Future Options:
  //     // { label: "Change Status", value: "change_status", viewType: "switch" },
  //     // { label: "Approve", value: "approve", viewType: "switch" },
  //   ],
  // },
  {
    display_name: "Production Plan",
    name: "production_plan",
    options: [
      { label: "View", value: "read", viewType: "checkbox" },
      { label: "Add", value: "add", viewType: "checkbox" },
      { label: "Edit", value: "edit", viewType: "checkbox" },
      { label: "Delete", value: "delete", viewType: "checkbox" },
    ],
  },
  {
    display_name: "Installation Plan",
    name: "installation_plan",
    options: [
      { label: "View", value: "read", viewType: "checkbox" },
      { label: "Add", value: "add", viewType: "checkbox" },
      { label: "Edit", value: "edit", viewType: "checkbox" },
      { label: "Delete", value: "delete", viewType: "checkbox" },
    ],
  },
  {
    display_name: "Sales commission",
    name: "sales_commission",
    options: [
      { label: "View", value: "read", viewType: "checkbox" },
      { label: "Add", value: "add", viewType: "checkbox" },
      { label: "Edit", value: "edit", viewType: "checkbox" },
      { label: "Delete", value: "delete", viewType: "checkbox" },
    ],
  },
  {
    display_name: "Clients/Distributors",
    name: "clients_distributors",
    options: [
      { label: "View", value: "read", viewType: "checkbox" },
      { label: "Add", value: "add", viewType: "checkbox" },
      { label: "Edit", value: "edit", viewType: "checkbox" },
      { label: "Delete", value: "delete", viewType: "checkbox" },
      {
        label: "For All Users",
        value: "access_of_all_user",
        viewType: "switch",
      },
    ],
  },
  {
    display_name: "Team Members",
    name: "team_members",
    options: [
      { label: "View", value: "read", viewType: "checkbox" },
      { label: "Add", value: "add", viewType: "checkbox" },
      { label: "Edit", value: "edit", viewType: "checkbox" },
      { label: "Delete", value: "delete", viewType: "checkbox" },
      {
        label: "Manage Employee Profile",
        value: "manage_employee_profile",
        viewType: "checkbox",
      },
    ],
  },
  {
    display_name: "Employee Attendance",
    name: "employee_attendance",
    options: [
      { label: "View", value: "read", viewType: "checkbox" },
      { label: "Add", value: "add", viewType: "checkbox" },
      { label: "Edit", value: "edit", viewType: "checkbox" },
      { label: "Delete", value: "delete", viewType: "checkbox" },
    ],
  },
  {
    display_name: "Price Sheet",
    name: "price_sheet",
    options: [
      { label: "View", value: "read", viewType: "checkbox" },
      { label: "Add", value: "add", viewType: "checkbox" },
      { label: "Edit", value: "edit", viewType: "checkbox" },
      { label: "Delete", value: "delete", viewType: "checkbox" },
      // Future Options:
      // { label: "Import/Export", value: "import_export", viewType: "checkbox" },
    ],
  },
  {
    display_name: "Products",
    name: "products",
    options: [
      { label: "View", value: "read", viewType: "checkbox" },
      { label: "Add", value: "add", viewType: "checkbox" },
      { label: "Edit", value: "edit", viewType: "checkbox" },
      { label: "Delete", value: "delete", viewType: "checkbox" },
    ],
  },
  {
    display_name: "Showroom Stock",
    name: "off_shelf_products",
    options: [
      { label: "View", value: "read", viewType: "checkbox" },
      { label: "Add", value: "add", viewType: "checkbox" },
      { label: "Edit", value: "edit", viewType: "checkbox" },
      { label: "Delete", value: "delete", viewType: "checkbox" },
    ],
  },
  {
    display_name: "Ecommerce",
    name: "ecommerce",
    options: [
      { label: "View", value: "read", viewType: "checkbox" },
      { label: "Add", value: "add", viewType: "checkbox" },
      { label: "Edit", value: "edit", viewType: "checkbox" },
      { label: "Delete", value: "delete", viewType: "checkbox" },
    ],
  },
  {
    display_name: "Stock Manager",
    name: "stock_manager",
    options: [
      { label: "View", value: "read", viewType: "checkbox" },
      { label: "Add", value: "add", viewType: "checkbox" },
      { label: "Edit", value: "edit", viewType: "checkbox" },
      { label: "Delete", value: "delete", viewType: "checkbox" },
    ],
  },
  {
    display_name: "Process Manager",
    name: "process_manager",
    options: [
      { label: "View", value: "read", viewType: "checkbox" },
      { label: "Add", value: "add", viewType: "checkbox" },
      { label: "Edit", value: "edit", viewType: "checkbox" },
      { label: "Delete", value: "delete", viewType: "checkbox" },
    ],
  },
  {
    display_name: "Steel Coil Manager",
    name: "steel_coil_manager",
    options: [
      { label: "View", value: "read", viewType: "checkbox" },
      { label: "Add", value: "add", viewType: "checkbox" },
      { label: "Edit", value: "edit", viewType: "checkbox" },
      { label: "Delete", value: "delete", viewType: "checkbox" },
    ],
  },
  {
    display_name: "Parts Restriction",
    name: "parts_restriction",
    options: [
      { label: "View", value: "read", viewType: "checkbox" },
      { label: "Add", value: "add", viewType: "checkbox" },
      { label: "Edit", value: "edit", viewType: "checkbox" },
      { label: "Delete", value: "delete", viewType: "checkbox" },
    ],
  },
  {
    display_name: "Manage Load Notice",
    name: "manage_load_notice",
    options: [
      { label: "View", value: "read", viewType: "checkbox" },
      { label: "Add", value: "add", viewType: "checkbox" },
      { label: "Edit", value: "edit", viewType: "checkbox" },
      { label: "Delete", value: "delete", viewType: "checkbox" },
    ],
  },
  {
    display_name: "Load Notice Creator",
    name: "load_notice_creator",
    options: [
      { label: "View", value: "read", viewType: "checkbox" },
      { label: "Add", value: "add", viewType: "checkbox" },
      { label: "Edit", value: "edit", viewType: "checkbox" },
      { label: "Delete", value: "delete", viewType: "checkbox" },
    ],
  },
  {
    display_name: "Created Load Notice",
    name: "created_load_notice",
    options: [
      { label: "View", value: "read", viewType: "checkbox" },
      { label: "Add", value: "add", viewType: "checkbox" },
      { label: "Edit", value: "edit", viewType: "checkbox" },
      { label: "Delete", value: "delete", viewType: "checkbox" },
    ],
  },
  {
    display_name: "Services",
    name: "services",
    options: [
      { label: "View", value: "read", viewType: "checkbox" },
      { label: "Add", value: "add", viewType: "checkbox" },
      { label: "Edit", value: "edit", viewType: "checkbox" },
      { label: "Delete", value: "delete", viewType: "checkbox" },
    ],
  },
  {
    display_name: "Pallet Calculator",
    name: "pallet_calculator",
    options: [
      { label: "View", value: "read", viewType: "checkbox" },
      { label: "Add", value: "add", viewType: "checkbox" },
      { label: "Edit", value: "edit", viewType: "checkbox" },
      { label: "Delete", value: "delete", viewType: "checkbox" },
    ],
  },
  {
    display_name: "Uprights Program",
    name: "profile_program",
    options: [
      { label: "View", value: "read", viewType: "checkbox" },
      { label: "Add", value: "add", viewType: "checkbox" },
      { label: "Edit", value: "edit", viewType: "checkbox" },
      { label: "Delete", value: "delete", viewType: "checkbox" },
    ],
  },
  {
    display_name: "Quotation Email Format",
    name: "quotation_email_format",
    options: [
      { label: "View", value: "read", viewType: "checkbox" },
      { label: "Edit", value: "edit", viewType: "checkbox" },
    ],
  },
  // {
  //   display_name: "Reports",
  //   name: "reports",
  //   options: [
  //     { label: "View", value: "read", viewType: "checkbox" },
  //     { label: "Add", value: "add", viewType: "checkbox" },
  //     { label: "Edit", value: "edit", viewType: "checkbox" },
  //     { label: "Delete", value: "delete", viewType: "checkbox" },
  //     // Future Options:
  //     // { label: "Download/Export", value: "export", viewType: "checkbox" },
  //     // { label: "Print", value: "print", viewType: "checkbox" },
  //   ],
  // },

  // {
  //   display_name: "Manage Admins",
  //   name: "sub_admins",
  //   options: [
  //     { label: "View", value: "read", viewType: "checkbox" },
  //     { label: "Add", value: "add", viewType: "checkbox" },
  //     { label: "Edit", value: "edit", viewType: "checkbox" },
  //     { label: "Delete", value: "delete", viewType: "checkbox" },
  //   ],
  // },
  {
    display_name: "Settings",
    name: "settings",
    options: [
      { label: "View", value: "read", viewType: "checkbox" },
      { label: "Add", value: "add", viewType: "checkbox" },
      { label: "Edit", value: "edit", viewType: "checkbox" },
      { label: "Delete", value: "delete", viewType: "checkbox" },
    ],
  },
  {
    display_name: "HR & Payroll",
    name: "hr_settings",
    options: [
      { label: "View", value: "read", viewType: "checkbox" },
      { label: "Add", value: "add", viewType: "checkbox" },
      { label: "Edit", value: "edit", viewType: "checkbox" },
      { label: "Delete", value: "delete", viewType: "checkbox" },
    ],
  },
  {
    display_name: "Master Data",
    name: "master_data",
    options: [
      { label: "View", value: "read", viewType: "checkbox" },
      { label: "Add", value: "add", viewType: "checkbox" },
      { label: "Edit", value: "edit", viewType: "checkbox" },
      { label: "Delete", value: "delete", viewType: "checkbox" },
    ],
  },
  {
    display_name: "Notification & Email Templates",
    name: "notification_email_templates",
    options: [
      { label: "View", value: "read", viewType: "checkbox" },
      { label: "Add", value: "add", viewType: "checkbox" },
      { label: "Edit", value: "edit", viewType: "checkbox" },
      { label: "Delete", value: "delete", viewType: "checkbox" },
    ],
  },
  {
    display_name: "Roles & Permissions",
    name: "roles_permissions",
    options: [
      { label: "View", value: "read", viewType: "checkbox" },
      { label: "Add", value: "add", viewType: "checkbox" },
      { label: "Edit", value: "edit", viewType: "checkbox" },
      { label: "Delete", value: "delete", viewType: "checkbox" },
    ],
  },
  // {
  //   display_name: "Static Data",
  //   name: "static_data",
  //   options: [
  //     { label: "View", value: "read", viewType: "checkbox" },
  //     { label: "Add", value: "add", viewType: "checkbox" },
  //     { label: "Edit", value: "edit", viewType: "checkbox" },
  //     { label: "Delete", value: "delete", viewType: "checkbox" },
  //   ],
  // },
  {
    display_name: "Sage",
    name: "sage",
    options: [
      { label: "View", value: "read", viewType: "checkbox" },
      { label: "Add", value: "add", viewType: "checkbox" },
      { label: "Edit", value: "edit", viewType: "checkbox" },
      { label: "Delete", value: "delete", viewType: "checkbox" },
    ],
  },
  {
    display_name: "Clock-In History",
    name: "clock_in_history",
    options: [
      { label: "View", value: "read", viewType: "checkbox" },
      { label: "Add", value: "add", viewType: "checkbox" },
      { label: "Edit", value: "edit", viewType: "checkbox" },
      { label: "Delete", value: "delete", viewType: "checkbox" },
    ],
  },
  {
    display_name: "Static Pages",
    name: "static_pages",
    options: [
      { label: "View", value: "read", viewType: "checkbox" },
      { label: "Add", value: "add", viewType: "checkbox" },
      { label: "Edit", value: "edit", viewType: "checkbox" },
      { label: "Delete", value: "delete", viewType: "checkbox" },
    ],
  },
];

export const RedirectLoginPermissionArray = [
  { name: "dashboard", path: "/dashboard", disabled: false },
  { name: "projects", path: "/projects", disabled: false },
  { name: "quotations", path: "/quotations", disabled: false },
  { name: "pallet_calculator", path: "/pallet-calculator", disabled: false },
  { name: "profile_program", path: "/profile-program", disabled: false },
  { name: "orders", path: "/orders", disabled: false },
  // { name: "jobs", path: "/jobs", disabled: false },
  { name: "production_plan", path: "/production-plan", disabled: false },
  { name: "installation_plan", path: "/installation-plan", disabled: false },
  { name: "sales_commission", path: "/sales-commission", disabled: false },
  {
    name: "clients_distributors",
    path: "/clients-distributors",
    disabled: false,
  },
  { name: "team_members", path: "/team-members", disabled: false },
  { name: "clock_in_history", path: "/clock-in-history", disabled: false },
  { name: "price_sheet", path: "/price-sheet", disabled: false },
  { name: "products", path: "/products", disabled: false },
  { name: "off_shelf_products", path: "/off-self-products", disabled: false },
  { name: "ecommerce", path: "/ecommerce/categories", disabled: false },
  { name: "parts_restriction", path: "/parts-restriction", disabled: false },
  { name: "services", path: "/services", disabled: false },
  { name: "sub_admins", path: "/sub-admins", disabled: false },
  { name: "settings", path: "/settings", disabled: false },
  {
    name: "process_manager",
    path: "/process-manager/bom-search",
    disabled: false,
  },
  {
    name: "master_data",
    path: "/master-data/installation-checklist",
    disabled: false,
  },
  {
    name: "hr_settings",
    path: "/hr-settings/settings",
    disabled: false,
  },
  {
    name: "notification_email_templates",
    path: "/notification-email-templates",
    disabled: false,
  },
  {
    name: "roles_permissions",
    path: "/roles-and-permissions",
    disabled: false,
  },
  { name: "static_data", path: "/static-data", disabled: false },
  { name: "static_pages", path: "/static-pages", disabled: false },
  { name: "stock_manager", path: "/stock-manager", disabled: false },
  {
    name: "process_manager",
    path: "/process-manager",
    disabled: false,
  },
  {
    name: "steel_coil_manager",
    path: "/steel-coil-manager",
    disabled: false,
  },
  {
    name: "manage_load_notice",
    path: "/manage-load-notice/adjustable-pallet-racking",
    disabled: false,
  },
  {
    name: "invoice",
    path: "/invoices",
    disabled: !isInvoiceFeatureEnabled,
  },
  {
    name: "sage",
    path: "/sage",
    disabled: false,
  },
  {
    name: "quote_requests",
    path: "/quote-requests",
    disabled: false,
  },
];

export const PagePermissionNameData = {
  DASHBOARD: "dashboard",
  PROJECTS: "projects",
  QUOTATIONS: "quotations",
  PALLET_CALCULATOR: "pallet_calculator",
  PROFILE_PROGRAM: "profile_program",
  ORDERS: "orders",
  JOBS: "jobs",
  PRODUCTION_PLAN: "production_plan",
  INSTALLATION_PLAN: "installation_plan",
  SALES_COMMISSION: "sales_commission",
  CLIENTS_DISTRIBUTORS: "clients_distributors",
  TEAM_MEMBERS: "team_members",
  CLOCK_IN_HISTORY: "clock_in_history",
  PRICE_SHEET: "price_sheet",
  PRODUCTS: "products",
  OFF_SHELF_PRODUCTS: "off_shelf_products",
  PARTS_RESTRICTION: "parts_restriction",
  SERVICES: "services",
  SUB_ADMINS: "sub_admins",
  SETTINGS: "settings",
  MASTER_DATA: "master_data",
  HR_SETTINGS: "hr_settings",
  NOTIFICATION_EMAIL_TEMPLATES: "notification_email_templates",
  ROLES_PERMISSIONS: "roles_permissions",
  STATIC_DATA: "static_data",
  STATIC_PAGES: "static_pages",
  STOCK_MANAGER: "stock_manager",
  PROCESS_MANAGER: "process_manager",
  STEEL_COIL_MANAGER: "steel_coil_manager",
  INVOICE: "invoice",
  SAGE: "sage",
  MANAGE_LOAD_NOTICE: "manage_load_notice",
  LOAD_NOTICE_CREATOR: "load_notice_creator",
  QUOTE_REQUESTS: "quote_requests",
  ESTIMATIONS: "estimate",
  QUOTATION_EMAIL_FORMAT: "quotation_email_format",
  CREATED_LOAD_NOTICE: "created_load_notice",
  EMPLOYEE_ATTENDANCE: "employee_attendance",
  EMPLOYEE_NOTES: "employee_notes",
  ECOMMERCE: "ecommerce",
};
const DEFAULT_PERMISSIONS = {
  READ: false,
  ADD: false,
  MODIFY: false,
  REMOVE: false,
  MANAGE_EMPLOYEE_PROFILE: false,
};

const FULL_PERMISSIONS = {
  READ: true,
  ADD: true,
  MODIFY: true,
  REMOVE: true,
  MANAGE_EMPLOYEE_PROFILE: true,
};

export const usePermissionsChecker = (module: string) => {
  const { user: ReduxUser } = useAppSelector((state: RootState) => state.auth);

  const user = ReduxUser ? ReduxUser : getDecryptedUserData();
  const activeRole = getActiveRole(user?.role);

  if (activeRole?.key === ROLE.ADMIN) {
    return FULL_PERMISSIONS;
  }

  /* Rename permission to modulePermission to fix error */
  const modulePermission = activeRole?.permission?.find(
    (p: any) => p.name === module,
  );

  if (!modulePermission?.access?.length) {
    return DEFAULT_PERMISSIONS;
  }

  const accessSet = new Set(modulePermission.access);

  return {
    READ: accessSet.has("read"),
    ADD: accessSet.has("add"),
    MODIFY: accessSet.has("edit"),
    REMOVE: accessSet.has("delete"),
    MANAGE_EMPLOYEE_PROFILE: accessSet.has("manage_employee_profile"),
  };
};

/**
 * Permission checker for HR module notification settings.
 * Grants READ & MODIFY access to: Employee, HR, HR Manager, Admin, Sub Admin,
 * and any user who has HR Module (hr_settings) access.
 */
export const useHrModulePermission = () => {
  const { user } = useAppSelector((state: RootState) => state.auth);
  const activeRole = getActiveRole(user?.role);
  const roleKey = activeRole?.key;

  // These roles always have full access to HR notification toggles
  const hrAllowedRoles = [ROLE.ADMIN, ROLE.SUB_ADMIN, ROLE.HR, ROLE.HR_MANAGER];

  if (hrAllowedRoles.includes(roleKey)) {
    return FULL_PERMISSIONS;
  }

  // Check if the user is an employee (employees can manage their own HR notification settings)
  const userData = user as any;
  if (userData?.isEmployee) {
    return {
      READ: true,
      ADD: false,
      MODIFY: true,
      REMOVE: false,
      MANAGE_EMPLOYEE_PROFILE: false,
    };
  }

  // Check if user has HR Module access (hr_settings permission)
  const hrPermission = activeRole?.permission?.find(
    (p: any) => p.name === "hr_settings",
  );

  if (hrPermission?.access?.length) {
    const accessSet = new Set(hrPermission.access);
    return {
      READ: accessSet.has("read"),
      ADD: accessSet.has("add"),
      MODIFY: accessSet.has("edit"),
      REMOVE: accessSet.has("delete"),
      MANAGE_EMPLOYEE_PROFILE: accessSet.has("manage_employee_profile"),
    };
  }

  return DEFAULT_PERMISSIONS;
};

export { RoleTypesEnum };

export const ALLOWED_ROLES_FOR_EXCHANGE_RATE = [
  RoleTypesEnum.ADMIN,
  RoleTypesEnum.SUB_ADMIN,
  "financial-director",
];
